<template>
   <main>
		<HeaderTab 
            :title="componentTitle" 
            :back_action="onBack"
        />
        <div id="content">
            <shutter-panel />
        </div>
    </main>
</template>


<script type="text/javascript">
    import Shutter from '@/mixins/Shutter.js'
    import ShutterActs from '@/mixins/shutters-manager/Acts.js'

	export default {
        name: "ActManagement",
        mixins: [Shutter, ShutterActs],
		data () {
			return {
                /* Main view params */
                componentTitle: '',

                /* Context params */
                horse_ids_route: '',
                actes_ids_route: '',
                usage: 'add',
                lot: false,
                type_preselect:'',
                preselect: '' // valeur de réponse à préselectionner dans QuestionForm, lue depuis ?p= (query param)
			}
        },
        created() {
            if(this.$route.params.acte_id) {
                this.actes_ids_route = this.$route.params.acte_id.toString()
            }
            if(this.$route.params.horse_id) {
                this.horse_ids_route = this.$route.params.horse_id.toString()
            }
            if(this.$route.params.state) {
                this.usage = this.$route.params.state
            }
            if(this.$route.params.lot) {
                this.lot = this.$route.params.lot
            }
            if(this.$route.params.type_preselect) {
                this.type_preselect = this.$route.params.type_preselect
            }
            // ?p= permet de préselectionner une valeur de réponse dans QuestionForm (ex: résultat DG depuis la fiche contrat client)
            if(this.$route.query.p) {
                this.preselect = this.$route.query.p
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            init_component() {
                const date = this.$route.params.date ? new Date(this.$route.params.date) : null
                if(date) date.setHours(0,0,0,0)
                switch (this.usage) {
                    case 'modification':
                        this.setupActEdit(this.actes_ids_route, this.lot)
                        this.componentTitle = this.getTrad('acte.modifier_acte')
                        break
                    case 'validation':
                        this.setupActValidation(this.actes_ids_route)
                        this.componentTitle = this.getTrad('acte.valider_acte')
                        break
                    default:
                        // actes_ids_route est utilisé comme type_preselect quand il est fourni (deep-link vers un type d'acte)
                        this.setupActAdd(this.horse_ids_route, '', this.actes_ids_route || this.type_preselect, date, this.preselect)
                        this.componentTitle = this.getTrad('acte.ajouter_acte')
                        break
                }
            },

            onShuttersSubmit() {
                this.redirectPostSave()
            },

            redirectPostSave() {
                const from = this.$route.params.from
				const horse_id = this.$route.params.horse_id

                switch (from) {
                    case 'HorseFicheActes' :
                        this.$router.push({ name: from, params: horse_id })
                        break
                    case 'HorseFichePlanning' :
                        this.$router.push({ name: from, params: horse_id })
                        break
                    default :
                        this.$router.push({ name: from, params: {relaod: true} })
                }
            }
        },
        components: {
            HeaderTab: () => import('@/components/HeaderTab')
		},
    }
</script>
